export default {"src":"/_next/static/media/us.43d29e6b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};